const rPaths = {
  rPaths: {
    billing: 'gestion',
    login: 'login',
    notFound: 'no-encontrado'
  }
}

export default rPaths
